import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ReviewDisplayComponent } from '../review-display/review-display.component';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'public-review-display',
    templateUrl: './public-review-display.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ReviewDisplayComponent, DatePipe]
})
export class PublicReviewDisplayComponent extends ReviewDisplayComponent {
  @Input() showTitle = true;
}
